<template>
  <header class="dashboard-header">
    <div class="header-left">
      <h2 class="system-name">产品型号管理系统</h2>
      <span class="system-version">v1.0.0</span>
    </div>
    <div class="header-right">
      <button @click="doLogout" class="logout-btn">退出</button>
    </div>
  </header>
</template>

<script>
import { logout } from '../services/auth'
import { useRouter } from 'vue-router'

export default {
  name: 'DashboardHeader',
  setup() {
    const router = useRouter()
    
    function doLogout() {
      logout()
      router.push('/login')
    }
    
    return { doLogout }
  }
}
</script>

<style scoped>
.dashboard-header {
  height: 60px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.system-name {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.system-version {
  color: #666;
  font-size: 14px;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 12px;
}

.header-right {
  display: flex;
  align-items: center;
}

.logout-btn {
  padding: 8px 16px;
  border: none;
  background: #ff4757;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background: #ff3838;
}
</style>
